// extracted by mini-css-extract-plugin
module.exports = {"component":"q_k5F","headerLogo":"OvGkx","headerTextLogo":"_2DYti","headerIconsWrapper":"DoGTm","headerIcon":"Ph6fI"};